import React, { createContext, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const toast = useRef(null);

    const showSuccess = (summary, detail, life = 30000) => {
        toast.current.show({ severity: 'success', summary, detail, life });
    };

    const showError = (summary, detail, life = 30000) => {
        toast.current.show({ severity: 'error', summary, detail, life });
    };

    const showInfo = (summary, detail, life = 3000) => {
        toast.current.show({ severity: 'info', summary, detail, life });
    };

    const showWarn = (summary, detail, life = 3000) => {
        toast.current.show({ severity: 'warn', summary, detail, life });
    };

    return (
        <ToastContext.Provider value={{ showSuccess, showError, showInfo, showWarn }}>
            <Toast ref={toast} position="bottom-center" />
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);